import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  padding: theme.spacing(16, 0),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(10, 0),
  },
  '& .LSTextColumn': {
    width: theme.typography.pxToRem(600),
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing(5),
    },
  },
  '& .LSHeadingContainer': {
    marginBottom: theme.spacing(5),
    display: 'flex',
  },
  '& .LSHeadingLine': {
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(3),
    },
  },
  '& .LSParagraph': {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  '& .LSQuote': {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    fontStyle: 'italic',
  },
  '& .LSSignature': {
    color: theme.palette.text.secondary,
    textAlign: 'right',
    fontSize: theme.spacing(2.5),
    fontWeight: 400,
    fontFamily: "'Calligraffitti', cursive",
  },
  '& .LSImageColumn': {
    '& .LSLeadershipImage': {
      borderRadius: theme.spacing(0.5),
    },
  },
}));

export default StyledBox;
